import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _STATUS_CONFIG;
var __jsx = React.createElement;
import React from "react";
import classNames from "classnames";
import AwesomeIcon from "../../AwesomeIcon";
import { faCheckCircle, faCircleXmark, faClock, faExclamationCircle, faCircleCheck, faTriangleExclamation, faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { SUBMISSION_STATUS, ACR_STATUS } from "../../../constants/acr";
// Status groupings for styling
var SUBMITTED_STATUSES = [SUBMISSION_STATUS.SUBMITTED, ACR_STATUS.ENQUEUED, ACR_STATUS.LOADING, ACR_STATUS.RECEIVED, ACR_STATUS.POSTED];
var ACCEPTED_STATUSES = [SUBMISSION_STATUS.ACCEPTED, ACR_STATUS.ACCEPTED, ACR_STATUS.VALIDATION_SUCCESSFUL, ACR_STATUS.UPDATED_WITH_NEW_TRANSACTION];
var WARNING_STATUSES = [SUBMISSION_STATUS.PARTIALLY_SUCCESSFUL, ACR_STATUS.PARTIALLY_SUCCESSFUL];
var ERROR_STATUSES = [SUBMISSION_STATUS.VALIDATION_FAILED, SUBMISSION_STATUS.ERROR, SUBMISSION_STATUS.REJECTED, SUBMISSION_STATUS.FAILED, ACR_STATUS.FAILED, ACR_STATUS.VALIDATION_FAIL];
var STATUS_CONFIG = (_STATUS_CONFIG = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_STATUS_CONFIG, SUBMISSION_STATUS.PENDING, {
  icon: faClock,
  label: "PENDING"
}), SUBMISSION_STATUS.READY, {
  icon: faCircleCheck,
  label: "READY"
}), SUBMISSION_STATUS.SUBMITTING, {
  icon: faSpinner,
  label: "SUBMITTING"
}), SUBMISSION_STATUS.SUBMITTED, {
  icon: faCheckCircle,
  label: "SUBMITTED"
}), SUBMISSION_STATUS.ACCEPTED, {
  icon: faCheckCircle,
  label: "ACCEPTED"
}), SUBMISSION_STATUS.VALIDATION_FAILED, {
  icon: faTriangleExclamation,
  label: "VALIDATION FAILED"
}), SUBMISSION_STATUS.PARTIALLY_SUCCESSFUL, {
  icon: faTriangleExclamation,
  label: "PARTIALLY SUCCESSFUL"
}), SUBMISSION_STATUS.ERROR, {
  icon: faCircleXmark,
  label: "ERROR"
}), SUBMISSION_STATUS.REJECTED, {
  icon: faExclamationCircle,
  label: "REJECTED"
}), SUBMISSION_STATUS.FAILED, {
  icon: faCircleXmark,
  label: "FAILED"
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_STATUS_CONFIG, ACR_STATUS.ENQUEUED, {
  icon: faCheckCircle,
  label: "ENQUEUED"
}), ACR_STATUS.LOADING, {
  icon: faSpinner,
  label: "LOADING"
}), ACR_STATUS.RECEIVED, {
  icon: faCheckCircle,
  label: "RECEIVED"
}), ACR_STATUS.POSTED, {
  icon: faCheckCircle,
  label: "POSTED"
}), ACR_STATUS.ACCEPTED, {
  icon: faCheckCircle,
  label: "ACCEPTED"
}), ACR_STATUS.VALIDATION_SUCCESSFUL, {
  icon: faCheckCircle,
  label: "VALIDATION SUCCESSFUL"
}), ACR_STATUS.PARTIALLY_SUCCESSFUL, {
  icon: faTriangleExclamation,
  label: "PARTIALLY SUCCESSFUL"
}), ACR_STATUS.VALIDATION_FAIL, {
  icon: faTriangleExclamation,
  label: "VALIDATION FAIL"
}), ACR_STATUS.FAILED, {
  icon: faCircleXmark,
  label: "FAILED"
}), ACR_STATUS.UPDATED_WITH_NEW_TRANSACTION, {
  icon: faCheckCircle,
  label: "UPDATED"
}));
var SubmissionStatusBadge = function SubmissionStatusBadge(_ref) {
  var status = _ref.status,
    acrStatus = _ref.acrStatus;
  // Prefer acr_status over internal status for display
  var submissionStatus = acrStatus || status.toLowerCase();
  var config = STATUS_CONFIG[submissionStatus];
  return /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("text-md px-3 py-1 flex gap-2 items-center rounded-full whitespace-nowrap font-medium", {
      "bg-amber-500 text-white dark:bg-amber-900 dark:text-amber-400": submissionStatus === SUBMISSION_STATUS.PENDING,
      "bg-sky-500 text-white dark:bg-sky-900 dark:text-sky-400": submissionStatus === SUBMISSION_STATUS.READY,
      "bg-blue-500 text-white dark:bg-blue-900 dark:text-blue-400": submissionStatus === SUBMISSION_STATUS.SUBMITTING,
      "bg-teal-400 text-white dark:bg-teal-900 dark:text-teal-400": SUBMITTED_STATUSES.includes(submissionStatus),
      "bg-emerald-500 text-white dark:bg-emerald-900 dark:text-emerald-400": ACCEPTED_STATUSES.includes(submissionStatus),
      "bg-orange-500 text-white dark:bg-orange-900 dark:text-orange-400": WARNING_STATUSES.includes(submissionStatus),
      "bg-red-600 text-white dark:bg-red-900 dark:text-red-300": ERROR_STATUSES.includes(submissionStatus)
    })
  }, (config === null || config === void 0 ? void 0 : config.icon) && /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: config.icon,
    size: "sm"
  }), (config === null || config === void 0 ? void 0 : config.label) || status.toUpperCase()));
};
export default SubmissionStatusBadge;